export default __webpack_public_path__ + "static/media/hybrid-circle.086c7169.svg";